import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
const JapanPostalCodeMarkWUT = () => {
  return /*#__PURE__*/React.createElement(Text, null, '\u3012');
};
export default JapanPostalCodeMarkWUT;
//# sourceMappingURL=japan-postal-code-mark-wut.js.map